'use strict';

import $ from 'jquery';
import doT from 'dot';

export default class Cart {
  constructor() {

    if($('.shopping-cart').length) {

      // get the ajax url
      let ajaxUrl = $('.shopping-cart').data('ajaxUrl'), // api url to get the cart items based on product ids
          storeDataUrl = $('#checkout').data('storeUrl'), // backend api url where the data data storing will be performed
          cart = {}, // this is cart object
          returnJsonData = {}; // this is the complete return data object for cart items

      cart.products = []; // initially the products in the cart object will be empty array

      if(typeof(Storage) !== "undefined") {
        if(localStorage.getItem("productsInCart") !== null) {
          cart.products = JSON.parse(localStorage.getItem("productsInCart"));
        }
      }
      let productsInCart = cart.products;

      // Function to calculate the cart quantity
      function updateCartQuantity() {
        let cartQuantity = 0;
        productsInCart.forEach(function(product) {
          cartQuantity += Number(product.prodQty);
        });
        $('.cart-menu .cart-items').text('('+cartQuantity+')'); // update the cart the return value
      }

      // the cart object will look like this
      // let cart = {
      //   products: [
      //     {
      //       productId: 1,
      //       prodQty: 1
      //     },
      //     {
      //       productId: 2,
      //       prodQty: 1
      //     },
      //     {
      //       productId: 3,
      //       prodQty: 1
      //     }
      //   ],
      //   promocode: "RAGUINDHU",
      //   collectionMethod: "self",
      //   country: "Singapore"
      // }

      // function for ajaxCall
      let ajaxCall = function(ajaxUrl, dataParams, promo=false) {
        $.ajax({
          url: ajaxUrl,
          method: 'POST',
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          // data: dataParams,
          data: JSON.stringify(dataParams),
          success: function(result) {
            processData(result, promo); // refer the processData function
          },
          error: function(error) {
            console.log(error)
          }
        });
      };

      // function to process the retun json from backend
      let processData = function processData(result, promo) {
        returnJsonData = result;
        // $('#cartViewModel').val(returnJsonData); // For eNets payment integration. Setting the return data in hidden input field
        let cartTemplate =  doT.template($('#cartTemplate').html()), // get the cart template from cart page and pass it to dot
            cartItems = result.items,
            list = [];
        cartItems.forEach(function(cartItem, i) {
          list[i] = {
            name: cartItem.name,
            prodid: cartItem.prodid,
            price: cartItem.price,
            quantity: cartItem.quantity,
            image: cartItem.image,
            alt: cartItem.alt,
            issue: cartItem.issue,
            cover: cartItem.cover
          };
        });


        let resultCartItems = cartTemplate(list);
        $('.cart__content').html(resultCartItems); // update the cart summary with the new datas


        let cartSummaryTemplate =  doT.template($('#cartSummaryTemplate').html()), // get the cart summary template from cart page and pass it to dot
            cartSummary = result.cartSummary,
            resultCartSummary = cartSummaryTemplate(cartSummary); // pass the cartSummary object to doT template.


        $('.cart-summary').html(resultCartSummary); // update the cart summary with the new datas
        if(promo) { //Run this only if clicked on promo button
          if(cartSummary.promocode) {
            $('.promocode-wrap .promo-msg').html('<span class="success")>Promo code applied</span>'); // show success notification for promo
          } else {
            $('.promocode-wrap .promo-msg').html('<span class="error")>Invalid Promo code</span>'); // show failure notification to user
          }
        }
      };


      // if cart is not empty, then load the cart items
      if(productsInCart.length) {
        ajaxCall(ajaxUrl, cart);
      }



      // apply promocode
      $('.promocode-btn').on('click.applyPromo', function(event) {
        event.preventDefault();
        let promoCode = $('.promocode-input').val();
        cart.promocode = promoCode; // add property as promocode to cart object
        if(promoCode.length > 3) {
          ajaxCall(ajaxUrl, cart, true);
        }
      });

      // remove item from cart
      $('.cart__content').on('click.removeItem', '.cart__close', function() {
        let prodId = $(this).closest('.cart__item').data('prodid');
          cart.products = productsInCart.filter(product => product.productId != prodId );
          productsInCart = cart.products;

        if(typeof(Storage) !== "undefined") {
          localStorage.productsInCart = JSON.stringify(productsInCart); // set local storage value
          $('.mobile-cart-icon .cart-items').addClass('has-item'); // update the cart icon in mobile
        }

        updateCartQuantity();
        ajaxCall(ajaxUrl, cart);
      });


      // on change collection Mode
      $('input[name="collection-mode"]').on('change', function() {
        cart.collectionMethod = $(this).val();
        cart.country = $('.country').val();
        ajaxCall(ajaxUrl, cart);
      });


      // on change shipping country
      $('.country').on('change', function() {
        cart.country = $(this).val();
        ajaxCall(ajaxUrl, cart);
      });


      // on change collection Mode
      $('.cart__content').on('change', '.cart__qty input', function() {
        let prodId = $(this).closest('.cart__item').data('prodid'),
            qty = $(this).val();

        // validate the quantity and make sure the min quantity is 1
        if(qty < 1) {
          qty = 1;
          $(this).val(qty);
        }

        if(typeof(Storage) !== "undefined") {
          if(localStorage.getItem("productsInCart") !== null) {
            productsInCart = JSON.parse(localStorage.getItem("productsInCart"));
          }
        }

        let findProductInCart = productsInCart.find(function(product) {
          return product.productId == prodId;
        });

        if(findProductInCart) {
          findProductInCart.prodQty = Number(qty);
        }

        if(typeof(Storage) !== "undefined") {
          localStorage.productsInCart = JSON.stringify(productsInCart); // set local storage value
          $('.mobile-cart-icon .cart-items').addClass('has-item'); // update the cart icon in mobile
        }
        updateCartQuantity();
        cart.products = productsInCart;
        ajaxCall(ajaxUrl, cart);
      });


      $('.checkout-btn').on('click', function(event) {
        event.preventDefault(); // Stop form submission
        let $fullName = $('#name'),
            $email = $('#email'),
            $tel = $('#telephone'),
            $country = $('#country'),
            $address = $('#address'),
            $collectionMode = $('.collection__methods'),
            $terms = $('.terms'),
            $postalCode = $('#postalcode'),
            valError = false,
            user = {};

        // Collection Mode
        if($('input[name="collection-mode"]:checked', $collectionMode).val() == undefined) {
          $collectionMode.next('.error').html('Please select your preferred collection method');
          valError = true;
        } else {
          $collectionMode.next('.error').html('');
          user.collection = $('input[name="collection-mode"]:checked').val();
        }

        // Terms validation
        if(!$('.terms-chkbox:checked', $terms).length) {
          $terms.find('.error').html('Please agree to the terms and conditons');
          valError = true;
        } else {
          $terms.find('.error').html('');
        }

        // Validate Name
        if($fullName.val().length < 3) {
          $fullName.next('.error').html('Please enter valid Name');
          valError = true;
        } else {
          $fullName.next('.error').html('');
          user.fullName = $fullName.val();
        }

        // Validate Email
        /* Email Validation RegEx */
        let validateEmail = function(email) {
          let reg = /\S+@\S+\.\S+/;
          return reg.test(email);
        }

        if(!validateEmail($email.val())) {
          $email.next('.error').html('Please enter valid Email');
          valError = true;
        } else {
          $email.next('.error').html('');
          user.email = $email.val();
        }

        // Validate Telephone
        if($tel.val().length < 8) {
          $tel.next('.error').html('Please enter valid Telephone number');
          valError = true;
        } else {
          $tel.next('.error').html('');
          user.telephone = $tel.val();
        }

        // Validate Postalcode
        if($postalCode.val().length) {
          user.postalCode = $postalCode.val();
        }

        // Validate Address
        if($address.val().length < 4) {
          $address.next('.error').html('Please enter valid Address');
          valError = true;
        } else {
          $address.next('.error').html('');
          user.address = $address.val();
        }

        user.country = $country.val();

        if(valError) {
          $(this).next('.error').html('There are still some fields missing. Please fill up them to proceed.')
        } else {
          if(returnJsonData.noOfItemsInCart > 0) {
            $.ajax({
              url: storeDataUrl,
              method: 'POST',
              contentType: 'application/json; charset=utf-8',
              data: JSON.stringify({user, cart: returnJsonData}), // pass both user info and cart info
              success: function(result) {
                if(typeof(Storage) !== "undefined") {
                  localStorage.removeItem("productsInCart"); // clear localStorage
                }
                $('body').append(result);
                $('#CugeShoppingCartNetsForm').submit();
              },
              error: function(error) {
                console.log(error)
              }
            });
          }
        }
      });
    }

  }

}
